import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { logOut } from '../../../actions/adminActions'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container } from 'reactstrap'
import { FaCog } from 'react-icons/fa'

class NavBar extends Component {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false
    }
  }
  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    return (
      <div>
        <Navbar color='dark' dark fixed='top' expand='md'>
          <Container>
            <NavbarBrand href='/admin'>Appeals Admin</NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className='ml-auto' navbar>
                <NavItem>
                  <Link className={`nav-link ${(this.props.location.pathname === '/admin' || this.props.location.pathname.includes('/appeal')) ? 'active' : ''}`} to='/admin'>Appeals</Link>
                </NavItem>
                <NavItem>
                  <Link className={`nav-link ${(this.props.location.pathname.includes('/response')) ? 'active' : ''}`} to='/admin/responses'>Response Library</Link>
                </NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    <FaCog /> {this.props.admin.auth ? `${this.props.admin.auth.first_name} ${this.props.admin.auth.last_name}` : ''}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <Link className='nav-link-dropdown' to='/admin/users'>Users</Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link className='nav-link-dropdown' to='/admin/reasons'>Reasons</Link>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>
                      <div className='nav-link-dropdown' onClick={this.props.logOut}>Logout</div>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    )
  }
}

NavBar.propTypes = {
  admin: PropTypes.object,
  logOut: PropTypes.func,
  location: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logOut
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBar))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminLayout/NavBar.jsx